<form [formGroup]="form" autocomplete="off" class="form-horizontal">

    <div class="form-row">
        <label class="d-none d-sm-inline col-sm-4 col-form-label">
            {{ 'COMMON_UI.PERSONENSTAMMDATEN.TITEL' | translate }}
        </label>
        <label class="d-sm-none col-form-label"
               for="titel{{index}}">{{ 'COMMON_UI.PERSONENSTAMMDATEN.TITEL' | translate }}</label>
        <div class="col-sm-4">
            <input class="form-control" datevMessagePath="titel{{objectId}}" formControlName="titel" id="titel{{index}}"
                   type="text"
                   utilsCheckValidity utilsControlState utilsValidationMessage/>
        </div>
    </div>

    <div class="form-row">
        <label class="col-sm-4 col-form-label"
               for="vorname{{index}}">{{ 'COMMON_UI.PERSONENSTAMMDATEN.VORNAME' | translate }}</label>
        <div class="col-sm-8">
            <input
                    (change)="onNameChange()"
                    class="form-control" datevMessagePath="vorname{{objectId}}" formControlName="vorname"
                    id="vorname{{index}}" type="text"
                    utilsCheckValidity utilsControlState utilsMarkRequired utilsValidationMessage/>
        </div>
    </div>

    <div class="form-row">
        <label class="col-sm-4 col-form-label"
               for="nachname{{index}}">{{ 'COMMON_UI.PERSONENSTAMMDATEN.NACHNAME' | translate }}</label>
        <div class="col-sm-8">
            <input
                    (change)="onNameChange()"
                    class="form-control" datevMessagePath="nachname{{objectId}}" formControlName="nachname"
                    id="nachname{{index}}" type="text"
                    utilsCheckValidity utilsControlState utilsMarkRequired utilsValidationMessage/>
        </div>
    </div>

    <div class="form-row">
        <label class="d-sm-none col-form-label"
               for="namensvorsatz{{index}}">{{ 'COMMON_UI.PERSONENSTAMMDATEN.NAMENSVORSATZ' | translate }}</label>
        <label class="d-none d-sm-inline col-sm-4 col-form-label">
            {{ 'COMMON_UI.PERSONENSTAMMDATEN.NAMENSVORSATZ_ZUSATZ' | translate }}</label>
        <div class="col-sm-4 col-lg-4">
            <input class="form-control" datevMessagePath="namensvorsatz{{objectId}}" formControlName="namensvorsatz"
                   id="namensvorsatz{{index}}"
                   type="text"
                   utilsCheckValidity utilsControlState utilsValidationMessage/>
        </div>

        <label class="d-sm-none col-form-label"
               for="namenszusatz{{index}}">{{ 'COMMON_UI.PERSONENSTAMMDATEN.NAMENSZUSATZ' | translate }}</label>
        <div class="col-sm-4">
            <input class="form-control" datevMessagePath="namenszusatz{{objectId}}" formControlName="namenszusatz"
                   id="namenszusatz{{index}}"
                   type="text"
                   utilsCheckValidity utilsControlState utilsValidationMessage/>
        </div>
    </div>

</form>
